export const isBoolean = (value) => "boolean" === typeof value;

export const formatInteger = (value) => {
  return value.replace(/\D/g, "").match(/\d+/g);
};

export const formatPhoneNumber = (value) => {
  if (value) {
    var x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    value = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  }
  return value;
};

export const formatMoney = (value) => {
  const regex = /^((-?[0-9]+\.?[0-9]?[0-9]?)|(-?[0-9]+)|-?)/g;
  const val = regex.exec(value);
  let formattedValue;

  if (val) {
    formattedValue = val[0];
  } else {
    formattedValue = "";
  }

  return formattedValue;
};

export const formatBonusMultiplier = (value) => {
  const regex = /^([0-9]+[\.]?[0-9]?[0-9]?[0-9]?[0-9]?|[0-9]+)/g;
  const val = regex.exec(value);
  let formattedValue;

  if (val) {
    formattedValue = val[0];
  } else {
    formattedValue = "";
  }

  return formattedValue;
};

export const simplifyPhoneNumber = (value) => {
  return value.replace(/\D/g, "");
};
